import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {RisorseService} from '../../../_services/risorse.service';
import {Risorsa} from '../../../_models/Risorsa';
import {SearchResult} from '../../../_models/SearchResult';
import {TipoRisorsa} from '../../../_models/generated/tipo-risorsa'
import {Subscription} from 'rxjs';
import {skip} from 'rxjs/operators';

@Component({
  selector: 'app-select-risorsa',
  templateUrl: './select-risorsa.component.html',
  styleUrls: ['./select-risorsa.component.scss'],
  standalone: false
})
export class SelectRisorsaComponent implements OnInit, OnDestroy {
  @Input() byCode = false;
  @Input() isString = false;
  @Input() risorsaValue: string;
  @Input() all = false;
  @Input() tipoRisorsa = -1;
  @Input() showLabel = true;
  @Input() excludedRisorsaIds: number[] = [];
  @Input() multiple = false;
  @Input() risorsaValues: (string | number)[] = [];
  @Output() risorsaValueChange = new EventEmitter<string>();
  @Output() risorsaChange = new EventEmitter<Risorsa>();
  @Output() risorsaValuesChange = new EventEmitter<(string | number)[]>();
  @Output() risorseSelezionateChange = new EventEmitter<Risorsa[]>();
  risorses = [];
  risorseList: Risorsa[] = [];
  loading = false;
  myRisorseSubscription: Subscription;
  private accountSettingsSubscription: Subscription;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    public risorseService: RisorseService) {
  }

  ngOnInit() {
    this.getRisorse();
    // skip(1): il caricamento iniziale è già gestito sopra, evita il doppio caricamento su init
    this.accountSettingsSubscription = this.organizzazioniService.currentAccountSettingsSubject
      .pipe(skip(1))
      .subscribe(() => this.getRisorse());
  }

  ngOnDestroy() {
    this.myRisorseSubscription?.unsubscribe();
    this.accountSettingsSubscription?.unsubscribe();
  }

  selectRisorsa = (e: SelectCustomEvent) => {
    if (this.multiple) {
      this.selectRisorseMultiple(e.target.value);
      return;
    }
    this.risorsaValue = this.isString ? e.target.value.toString() : e.target.value;
    this.risorsaValueChange.emit(this.risorsaValue);
    this.risorseList.forEach((risorsa: Risorsa) => {
      if (this.matchRisorsa(risorsa, this.risorsaValue)) {
        this.risorsaChange.emit(risorsa);
      }
    });
  };

  private matchRisorsa = (risorsa: Risorsa, value: string | number): boolean =>
    (this.byCode && risorsa.codice === value) || (!this.byCode && risorsa.id === +value);

  private selectRisorseMultiple = (raw: any) => {
    const values: (string | number)[] = Array.isArray(raw) ? raw : [];
    this.risorsaValues = this.isString ? values.map((v) => v.toString()) : values;
    this.risorsaValuesChange.emit(this.risorsaValues);
    const selezionate = this.risorseList.filter((risorsa: Risorsa) =>
      this.risorsaValues.some((value) => this.matchRisorsa(risorsa, value)));
    this.risorseSelezionateChange.emit(selezionate);
  };

  blurActiveElement() {
    const active = document.activeElement as HTMLElement | null;
    const nestedActive = active?.shadowRoot?.activeElement as HTMLElement | null;

    nestedActive?.blur();
    active?.blur();
  }

  getRisorse = () => this.organizzazioniService
    .risorsePersonal && !this.all ? this.getMyRisorse() : this.getRisorseLocalAsync();

  getMyRisorse() {
    this.myRisorseSubscription?.unsubscribe();
    this.myRisorseSubscription = this.risorseService.myRisorse
      .subscribe((_risorse: Risorsa[]) => this.setRisorse(_risorse ?? []));
  }

  getRisorseLocalAsync() {
    this.loading = true;
    this.risorses = [];
    this.risorseService
      .getRisorseFilteredAsync(this.organizzazioniService.organizzazioneId, '', 0, 0, 'codice', true, this.tipoRisorsa, '', true, true)
      .then((_risorse: SearchResult<Risorsa>) => this.setRisorse(_risorse.totalCount > 0 ? _risorse.result : []))
      .catch((_err) => console.error(_err))
      .finally(() => this.loading = false);
  }

  setRisorse = (_result: Risorsa[]) => {
    const excludedIds = new Set((this.excludedRisorsaIds ?? []).map((id: number) => Number(id)));
    this.risorses = [];
    this.risorseList = (_result ?? []).filter((_risorsa: Risorsa) => !excludedIds.has(Number(_risorsa.id)));
    if (this.risorseList.length > 0) {
      this.risorseList.forEach((_risorsa: Risorsa) => {
        if (this.tipoRisorsa < 0 || this.tipoRisorsa === _risorsa.tipoRisorsa || _risorsa.tipoRisorsa === TipoRisorsa.TUTTO) {
          this.risorses
            .push({
              value: this.byCode ? _risorsa.codice : _risorsa.id,
              label: `${_risorsa.codice}: ${_risorsa.descrizione}`
            });
        }
      });
    }
  };
}
